$(document).ready(function(){

//   $('body').find('.on-modal-to-confirm').removeClass('hide');
  
  var user = getCookie("username");
  if(user == ""){
    $('body').find('.on-modal-to-confirm').removeClass('hide');  
  } 

  if(user == "toronto"){
    $('body').addClass('toronto');
    let text = $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').attr('data-value');
    $('body').find('.on-location-select').find('span').text(text);
    $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').addClass('active');
    $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').removeClass('active');
  } else if(user == "outsidetoronto"){
    $('body').addClass('outsidetoronto');
    let text = $('body').find('.on-dropdown-wrapper').find('.on-item.outsidetoronto').attr('data-value');
    $('body').find('.on-location-select').find('span').text(text);
    $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').addClass('active');
    $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').removeClass('active');
  }

  $('body').on('click', '.on-toronto-btn', function(){

    setCookie("username", "toronto", 1);
    $('body').addClass('toronto');
    $(this).closest('.on-modal-to-confirm').addClass('hide');
    let text = $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').attr('data-value');
    $('body').find('.on-location-select').find('span').text(text);
    $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').addClass('active');
    $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').removeClass('active');

  });

  $('body').on('click', '.on-out-toronto-btn', function(){

    setCookie("username", "outsidetoronto", 1);
    $('body').addClass('outsidetoronto');
    $(this).closest('.on-modal-to-confirm').addClass('hide');
    let text = $('body').find('.on-dropdown-wrapper').find('.on-item.outsidetoronto').attr('data-value');
    $('body').find('.on-location-select').find('span').text(text);
    $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').addClass('active');
    $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').removeClass('active');

  });

  $('body').on('click', '.on-dropdown-wrapper .on-item', function(){
    if($(this).hasClass('toronto')){
      setCookie("username", "toronto", 1);
      $('body').addClass('toronto');
      $('body').removeClass('outsidetoronto');
      $('body').find('.on-location-select').find('span').text($(this).attr('data-value'));
      $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').addClass('active');
      $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').removeClass('active');
    } else if($(this).hasClass('outsidetoronto')){
      setCookie("username", "outsidetoronto", 1);
      $('body').addClass('outsidetoronto');
      $('body').removeClass('toronto');
      $('body').find('.on-location-select').find('span').text($(this).attr('data-value'));
      $('body').find('.on-dropdown-wrapper').find('li.on-item.outsidetoronto').addClass('active');
      $('body').find('.on-dropdown-wrapper').find('li.on-item.toronto').removeClass('active');
    }
  });

  $('body').find('.on-fillter-list li').each(function(){
    let content = $(this).closest('.on-fillter-content');
    if($(this).hasClass('active')){
      content.addClass('active');
      content.find('.on-list').slideDown();
      !$(this).hasClass('onshow') ? $(this).addClass('onshow') : null;
      content.find('.on-list').prepend($(this));
    }
  });

  $('body').on('click', '.on-fillter-title', function(){
    let content = $(this).closest('.on-fillter-content');
    if(!content.hasClass('active')){
      content.addClass('active');
      content.find('.on-list').slideDown();
    } else {
      content.removeClass('active');
      content.find('.on-list').slideUp();
    }
  });


  $('body').on('click', '.on-more-fillters', function(){
    let content = $(this).closest('.on-list');
    let limit = content.attr('data-limit');
    let step = content.attr('data-step');
    let count = parseInt(limit) + parseInt(step);
    content.find('li').each(function(key){
      if(key > step && key <= count){
        $(this).show();
        content.attr('data-step', step = parseInt(step) + 1);
      }
    });
  });
  
  
  $('body').on('click', '.on-fillter-open-mobile', function(){
    $('body').find('.on-category-wrapper').addClass('open');
  });
  
  $('body').on('click', '.on-close-fillter-mobile', function(){
    $('body').find('.on-category-wrapper').removeClass('open');
  });

});


function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
